import { render, staticRenderFns } from "./Extensions.vue?vue&type=template&id=ec6d8e1a&"
import script from "./Extensions.vue?vue&type=script&lang=js&"
export * from "./Extensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports